const faqs = [
  {
    q: '酷客影院是否需要注册或付费？',
    a: '酷客影院目前为免费在线观影平台，无需注册或付费即可访问全部高清电影与高清电视剧内容。我们致力于让每一位用户都能轻松享受超清播放体验。',
  },
  {
    q: '播放画质最高支持什么级别？',
    a: '平台支持1080P超清画质播放，部分热门内容更提供4K修复版本。默认画质根据你的网络状况自动适配，也可手动切换清晰度以获得最佳观影效果。',
  },
  {
    q: '为什么有些影片加载较慢？',
    a: '我们采用智能CDN加速技术，通常点击即播。如果遇到加载延迟，建议检查当前网络环境或尝试切换至其他线路。高峰时段可能会有短暂排队，我们会持续扩容服务器。',
  },
  {
    q: '支持哪些设备观看？',
    a: '酷客影院支持电脑、平板、手机全终端访问，无需下载任何软件或插件，通过浏览器即可直接在线观看。观影记录、播放进度可在不同设备间自动同步。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们每日更新50+部最新影视资源，包括影院新片、热门剧集、高分纪录片等。用户可通过首页「新片推荐」和「热门榜单」模块第一时间发现新上架内容。',
  },
  {
    q: '遇到播放问题如何反馈？',
    a: '如遇到播放卡顿、画面异常或内容缺失等问题，可通过页面底部的联系邮箱或联系我们模块提交反馈。我们会尽快排查并解决问题，确保你的观影体验不受影响。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              帮助中心
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              关于使用酷客影院的常见疑问，这里都有答案
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <details key={i} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-all shrink-0">
                    <i className="ri-add-line group-open:ri-subtract-line text-sm transition-all"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}